import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';
import { CheckCircle, User } from 'lucide-react';

const About = () => {
  const { t } = useLanguage();
  const aboutText = t(translations.about);

  return (
    <div className="min-h-screen">
      {/* Page Header */}
      <section className="bg-gradient-to-r from-[#0B1F3F] to-[#1a3a5f] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{aboutText.title}</h1>
          <p className="text-xl text-gray-200">{aboutText.subtitle}</p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed mb-12 text-center">
              {aboutText.description}
            </p>

            {/* Instructor Section */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl p-8 md:p-12 mb-12 border border-gray-100">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="w-32 h-32 bg-gradient-to-br from-[#FF6B35] to-[#FF8A5B] rounded-full flex items-center justify-center shadow-lg">
                  <User className="h-16 w-16 text-white" />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-2xl font-bold text-[#0B1F3F] mb-2">{aboutText.instructor}</h3>
                  <h4 className="text-3xl font-bold text-[#FF6B35] mb-4">{aboutText.instructorName}</h4>
                  <p className="text-gray-700 leading-relaxed">{aboutText.instructorDesc}</p>
                </div>
              </div>
            </div>

            {/* Why Learn with Us */}
            <div>
              <h3 className="text-3xl font-bold text-[#0B1F3F] mb-8 text-center">{aboutText.whyLearn}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {aboutText.points.map((point, index) => (
                  <div key={index} className="flex items-start space-x-3 p-4 bg-white rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                    <CheckCircle className="h-6 w-6 text-[#FF6B35] flex-shrink-0 mt-1" />
                    <span className="text-gray-700 font-medium">{point}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
